import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { oneAssetApi } from '../constants/constants'
import { RequestAnswerUHNW,RequestKaDetail } from 'src/app/constants/models';
@Injectable({
  providedIn: 'root'
})
export class AssetService {

  constructor(private http: HttpClient) {
  }

  getQuestionAsset(cusid:Number,type:string){
    let URL = oneAssetApi + '/UHNW/getQuestionAsset'
    let body = {
      customerid: cusid,
      type:type
    }
    
    return this.http.post(URL, body)
  }

  getQuestionTypeKnowledge(){
    let URL = oneAssetApi + '/UHNW/getQuestionTypeKnowledge'
    return this.http.get(URL)
  }

  saveUltraHNW(param:RequestAnswerUHNW){
    let URL = oneAssetApi + '/UHNW/saveUltraHNW'
    let body = {
      customerid: param.customerid,
      type: param.type,
      QuestionId: param.QuestionId
    }
    return this.http.post(URL,body)
  }

  getKnowledgeDetail(param:RequestKaDetail){
    let URL = oneAssetApi + '/UHNW/getKnowledgeDetail'
    let body = {
      Customerid: param.Customerid,
      KnowledgeId: param.KnowledgeId
    }
    return this.http.post(URL,body)
  }

  getAssetDetail(cusid:Number , type:String){
    let URL = oneAssetApi + '/UHNW/getAssetDetail'
    let body = {
      customerid: cusid,
      type: type
    }
    return this.http.post(URL,body)
  }

  getPopup(){ 
    let URL = oneAssetApi + '/info/popup?source=web'
    return this.http.get(URL);
  }

}
